import { makeAutoObservable } from "mobx"

export default class DraftComment {

  constructor(comment = {}) {
    this.id = comment.id
    this.authorName = comment.author_name
    this.authorAvatar = comment.author_avatar
    this.comment = comment.comment
    this.postedAt = comment.posted_at

    makeAutoObservable(this)
  }
}
